import React from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { 
  calculateTotalLoanAmount, 
  calculateTotalMonthlyPayment, 
  calculateTotalLoanPeriod 
} from '../userSettingsUtils';

const MortgageForm = ({
  formData,
  handleChange,
  banks,
  isMobile
}) => {
  // Calculate totals from tracks
  const totalLoanAmount = calculateTotalLoanAmount(formData.mortgageTracks);
  const totalMonthlyPayment = calculateTotalMonthlyPayment(formData.mortgageTracks);
  const totalLoanPeriod = calculateTotalLoanPeriod(formData.mortgageTracks);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AccountBalanceIcon />
        פרטי המשכנתא
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="bank-label">בנק</InputLabel>
            <Select
              labelId="bank-label"
              name="bank"
              value={formData.bank}
              onChange={handleChange}
              label="בנק"
              required
              sx={{ textAlign: "right" }}
              startAdornment={
                <InputAdornment position="start" sx={{ mr: 1 }}>
                  <AccountBalanceIcon color="action" />
                </InputAdornment>
              }
            >
              <MenuItem value=""><em>בחר בנק</em></MenuItem>
              {banks.map(bank => (
                <MenuItem key={bank.id} value={bank.name}>{bank.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="תאריך התחלה"
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarTodayIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="סכום הלוואה כולל"
            value={totalLoanAmount}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <Tooltip title="מחושב אוטומטית מסכום כל המסלולים">
                    <MonetizationOnIcon color="primary" />
                  </Tooltip>
                </InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">₪</InputAdornment>,
              style: { backgroundColor: "#f5f5f5" }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="תשלום חודשי כולל"
            value={totalMonthlyPayment}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <Tooltip title="מחושב אוטומטית מהתשלום החודשי של כל המסלולים">
                    <MonetizationOnIcon color="primary" />
                  </Tooltip>
                </InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">₪</InputAdornment>,
              style: { backgroundColor: "#f5f5f5" }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="תקופת הלוואה"
            value={totalLoanPeriod}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <Tooltip title="מחושב אוטומטית לפי התקופה הארוכה ביותר מבין המסלולים">
                    <InfoOutlinedIcon color="primary" />
                  </Tooltip>
                </InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">שנים</InputAdornment>,
              style: { backgroundColor: "#f5f5f5" }
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MortgageForm; 